import { Socket } from "socket.io-client";
import ClientChatPacket from "../ClientChatPacket";

export default class LogoutClientChatPacket extends ClientChatPacket {
    public constructor() {
        super();
    }

    public async send(socket: Socket) {
        await socket.emit('logout', {
        });
    }
}
